import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAQDNVJmAKVu3z8iZDbMo7xNhg8GaYyPnc",
  authDomain: "srma-46194.firebaseapp.com",
  projectId: "srma-46194",
  appId: "1:904478575981:web:881538c01b29e2fc2c1e64",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth, RecaptchaVerifier, signInWithPhoneNumber };